
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Minibusonrent() {



    const cardData =
    {
        keyword: 'Mini Bus On Rent',
        heading: 'Amruta Travels: Mini Bus On Rent',
        headingDescription: 'Amruta Travels offers Mini Bus on Rent in Pune, delivering a compact yet spacious travel solution for small and medium-sized groups. Whether it is a school trip, family function, office outing, or outstation tour, our well-maintained mini buses ensure a smooth, comfortable, and safe journey at budget-friendly prices.',


        top: 'Top Places to Visit in Outstation Goa with Amruta Travels',



"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "One of the most popular beaches in North Goa, Baga Beach is known for its vibrant nightlife, water sports, beach shacks, and music. It's perfect for jet skiing, banana boat rides, and soaking in the beach party vibes."
  },
  {
    "title": "Calangute Beach",
    "description": "Often called the 'Queen of Beaches,' Calangute is the largest beach in North Goa. Ideal for swimming and sunbathing, it also offers shopping stalls, local eateries, and adventure activities."
  },
  {
    "title": "Fort Aguada",
    "description": "A 17th-century Portuguese fort overlooking the Arabian Sea, Fort Aguada is a historic structure that offers scenic views and a glimpse into Goa’s colonial past. It also houses a centuries-old lighthouse."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "A UNESCO World Heritage Site, this church in Old Goa holds the mortal remains of St. Francis Xavier. It's renowned for its baroque architecture and spiritual significance."
  },
  {
    "title": "Anjuna Beach",
    "description": "Famous for its hippie vibe, Anjuna Beach is ideal for backpackers and adventure seekers. It also hosts a weekly flea market where you can shop for handicrafts, jewelry, and souvenirs."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Located on the Goa-Karnataka border, Dudhsagar is a spectacular four-tiered waterfall surrounded by lush greenery. It's best visited during the monsoon season and accessible via trekking or jeep rides."
  },
  {
    "title": "Chapora Fort",
    "description": "Known for the iconic scene from the Bollywood movie 'Dil Chahta Hai,' this fort offers breathtaking views of Vagator Beach and the Arabian Sea, making it a popular sunset point."
  },
  {
    "title": "Palolem Beach",
    "description": "A serene crescent-shaped beach in South Goa, Palolem is famous for its laid-back vibe, dolphin-spotting trips, and eco-huts. It’s perfect for peaceful getaways and kayaking."
  },
  {
    "title": "Colva Beach",
    "description": "Located in South Goa, Colva Beach is popular for its white sand stretches, vibrant nightlife, and a mix of locals and tourists. It’s great for swimming and beach walks."
  },
  {
    "title": "Shri Mangeshi Temple",
    "description": "One of the largest and most frequently visited Hindu temples in Goa, the Mangeshi Temple is dedicated to Lord Shiva. It's known for its elegant architecture and religious importance."
  }
],

   "services": [
    {
      "name": "Mini Bus on Rent",
      "description": "Rent a mini bus from Amruta Travels for your group trips within Pune or to outstation destinations. Our mini buses come with air conditioning, comfortable seating, and a professional driver to ensure a smooth journey."
    },
    {
      "name": "Mini Bus Hire in Pune",
      "description": "Amruta Travels offers a range of mini buses for hire in Pune. Whether you need a small group transport for a local event or an outstation trip, our mini buses are available for daily, weekly, and monthly rentals."
    },
    {
      "name": "Minibus Hire with Driver for Outstation",
      "description": "For your outstation trips, rent a mini bus with a professional driver from Amruta Travels. Our well-maintained mini buses ensure a comfortable, hassle-free journey, whether you're traveling for business or leisure."
    },
    {
      "name": "Mini Bus Rentals for Corporate Trip",
      "description": "Ensure your corporate trip is stress-free with Amruta Travels' mini bus rentals. Our mini buses are ideal for team outings, conferences, seminars, and other corporate events, with comfortable seating and professional drivers."
    },
    {
      "name": "Small Bus Rental Service in Pune",
      "description": "For small group trips, Amruta Travels provides small bus rentals in Pune. Perfect for local tours, family outings, or corporate events, our small buses offer comfortable and reliable transportation."
    },
    {
      "name": "Minibus Rental Near Me in Pune",
      "description": "Looking for a mini bus near you? Amruta Travels offers mini bus rentals throughout Pune. Our vehicles are available for local and outstation trips, with flexible rental options to suit your needs."
    },
    {
      "name": "Mini Bus Rent Per Km",
      "description": "Rent a mini bus from Amruta Travels at competitive rates, with a flexible per kilometer rental option. Ideal for short or long-distance trips, our mini buses are perfect for both local travel and outstation tours."
    },
    {
      "name": "Mini Coach Hire in Pune",
      "description": "Amruta Travels provides mini coach hire services in Pune. Whether it's for a family trip, corporate outing, or event, our mini coaches provide ample space, AC comfort, and professional drivers for a comfortable ride."
    },
    {
      "name": "Mini Bus for Rent Near Me in Pune",
      "description": "Amruta Travels offers mini buses for rent near you in Pune. From picnics to business trips, our mini buses are well-suited for all occasions, providing comfort, air conditioning, and safety."
    },
    {
      "name": "12 Seater Mini Bus on Rent in Pune",
      "description": "For smaller groups, rent a 12-seater mini bus from Amruta Travels. Our 12-seater mini buses are perfect for family trips, small group events, or local sightseeing tours in and around Pune."
    },
    {
      "name": "Mini Bus on Rent Near Me for Outstation",
      "description": "Need a mini bus for an outstation trip? Amruta Travels offers mini bus rentals near you in Pune, perfect for your family trips, corporate tours, or group outings to nearby cities."
    },
    {
      "name": "Mini Bus for Lonavala Picnic from Pune",
      "description": "Travel to Lonavala in comfort with Amruta Travels' mini bus rentals. Perfect for a family picnic or group outing, our mini buses come with air conditioning and plenty of space for a relaxed journey."
    },
    {
      "name": "Mini Bus Hire for Event in Pune",
      "description": "For any event in Pune, rent a mini bus from Amruta Travels. Our vehicles are ideal for weddings, parties, corporate events, or local tours, offering air conditioning, comfortable seating, and professional drivers."
    },
    {
      "name": "Pune to Goa Mini Bus",
      "description": "Travel to Goa with Amruta Travels' mini bus rental service. Our mini buses are perfect for groups heading to Goa, offering air conditioning, spacious interiors, and reliable drivers for a comfortable ride."
    },
    {
      "name": "Mini Bus Hire in Pimpri Chinchwad",
      "description": "Amruta Travels offers mini bus hire services in Pimpri Chinchwad. Whether you're planning a group trip, corporate outing, or event, our mini buses provide comfort, safety, and reliability."
    },
    {
      "name": "Mini Bus Hire in Kharadi Pune",
      "description": "Rent a mini bus in Kharadi from Amruta Travels for your next trip. Our mini buses are perfect for local or outstation trips, providing air-conditioned comfort and ample space for your group."
    },
    {
      "name": "Minibus Hire for Wedding Party in Pune",
      "description": "Make your wedding event transportation seamless with Amruta Travels' mini bus rental services. Our mini buses are perfect for guest transportation to and from wedding venues, offering comfort and style."
    },
    {
      "name": "Mini Bus On Rent in Hinjewadi",
      "description": "Amruta Travels offers mini bus rentals in Hinjewadi for both local and outstation trips. Our mini buses are equipped with air conditioning, comfortable seats, and reliable drivers to make your journey smooth."
    },
    {
      "name": "Mini Bus on Rent in Baner",
      "description": "If you're in Baner and need a mini bus for your group trip, Amruta Travels offers mini bus rentals with flexible packages, including options for local sightseeing or outstation trips."
    }
  ],
  "tableData": [
    ["Mini Bus on Rent", "Mini Bus Hire in Pune"],
    ["Minibus Hire with Driver for Outstation", "Mini Bus Rentals for Corporate Trip"],
    ["Small Bus Rental Service in Pune", "Minibus Rental Near Me in Pune"],
    ["Mini Bus Rent Per Km", "Mini Coach Hire in Pune"],
    ["Mini Bus for Rent Near Me in Pune", "12 Seater Mini Bus on Rent in Pune"],
    ["Mini Bus on Rent Near Me for Outstation", "Mini Bus for Lonavala Picnic from Pune"],
    ["Mini Bus Hire for Event in Pune", "Pune to Goa Mini Bus"],
    ["Mini Bus Hire in Pimpri Chinchwad", "Mini Bus Hire in Kharadi Pune"],
    ["Minibus Hire for Wedding Party in Pune", "Mini Bus On Rent in Hinjewadi"],
    ["Mini Bus on Rent in Baner", ""]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Convenient Mini Bus Rentals for Comfortable Group Travel",
    "WhyChoosedescription": "Amruta Travels offers mini buses on rent, providing an affordable and comfortable option for group travel. Whether you’re planning a corporate event, family outing, wedding transportation, or a school trip, our mini buses are equipped with modern amenities to ensure a pleasant journey for everyone."
  },
  {
    "WhyChooseheading": "Ideal for Small to Medium-Sized Groups",
    "WhyChoosedescription": "Our mini buses are perfect for transporting small to medium-sized groups comfortably. With seating capacity ranging from 15 to 30 passengers, they are ideal for family trips, corporate outings, and group tours. You can enjoy a comfortable ride without feeling cramped in a smaller vehicle."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Mini Bus Rentals",
    "WhyChoosedescription": "We offer competitive and transparent pricing for mini bus rentals. Our pricing is all-inclusive, covering fuel, tolls, driver allowances, and taxes. No hidden charges—just clear and affordable rates so you can plan your budget with ease."
  },
  {
    "WhyChooseheading": "Modern Amenities for a Comfortable Ride",
    "WhyChoosedescription": "Our mini buses come equipped with air conditioning, comfortable seating, ample legroom, entertainment systems, and USB charging ports. With these features, your group can enjoy a comfortable, enjoyable ride to any destination, whether it's a short trip or a long journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for Safe Travel",
    "WhyChoosedescription": "All of our mini buses are driven by experienced, professional drivers who are well-trained in safe driving practices and customer service. They ensure that your trip is safe, timely, and smooth, whether you’re traveling locally or going on a long-distance journey."
  },
  {
    "WhyChooseheading": "Flexible Rental Options for Mini Bus Hire",
    "WhyChoosedescription": "We offer flexible rental options for mini buses to suit your needs, whether it's an hourly, daily, or multi-day rental. You can rent a mini bus for a one-time event or for a long-term contract, depending on your requirements."
  },
  {
    "WhyChooseheading": "Convenient Online Booking and 24/7 Support",
    "WhyChoosedescription": "Booking a mini bus rental with Amruta Travels is simple and quick. You can book your vehicle online or contact our customer service team for assistance. Our 24/7 support ensures you can get help with any inquiries or last-minute changes to your booking."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Wedding, and Group Events",
    "WhyChoosedescription": "Our mini buses are perfect for corporate functions, wedding parties, school excursions, and group tours. Whether it’s transporting employees to a conference or guests to a wedding, our mini buses provide both comfort and convenience, making sure everyone arrives on time and in style."
  }
]






















    }

const faqData = [
  {
    question: 'Can I rent a mini bus with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers mini buses for rent, perfect for group transportation. Whether you need it for a family trip, corporate event, or school outing, our mini buses provide comfort, safety, and convenience.',
  },
  {
    question: 'What are the seating capacities available for mini buses on rent?',
    answer: 'Our mini buses come in various seating configurations, including 16-seater, 20-seater, 24-seater, and 30-seater, ensuring a comfortable ride for both small and larger groups.',
  },
  {
    question: 'Is a driver included with the mini bus rental?',
    answer: 'Yes, all mini bus rentals come with a professional and experienced driver. Our drivers are trained to provide a safe and smooth travel experience, ensuring your journey is stress-free.',
  },
  {
    question: 'How much does it cost to rent a mini bus?',
    answer: 'The cost of renting a mini bus depends on factors such as the seating capacity, trip duration, and distance. We provide competitive rates and can offer customized quotes based on your specific requirements. Contact us for more details.',
  },
  {
    question: 'Can I rent a mini bus for both local and outstation trips?',
    answer: 'Yes, our mini buses are available for both local trips within the city and outstation journeys to popular destinations. Whether it’s a day trip or a longer excursion, we ensure a comfortable ride.',
  },
  {
    question: 'Are the mini buses well-maintained and sanitized?',
    answer: 'Yes, all our mini buses are regularly serviced and thoroughly sanitized before every trip to ensure the highest standards of hygiene and comfort.',
  },
  {
    question: 'Can I book a mini bus online?',
    answer: 'Yes, you can easily book a mini bus through our website or by contacting our customer support team. We will guide you through the booking process and provide all the necessary details.',
  },
  {
    question: 'What types of events can I rent a mini bus for?',
    answer: 'Our mini buses are perfect for a wide range of events, including corporate outings, family gatherings, weddings, school trips, group tours, and airport transfers. They provide a comfortable and convenient way to travel with a group.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    role: 'Marketing Head, Pune',
    text: 'We rented a 24-seater mini bus for a corporate event. The vehicle was spacious, clean, and well-maintained. The driver was punctual and professional. Amruta Travels provided an excellent experience!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Deshmukh',
    role: 'Event Organizer, Pune',
    text: 'I rented a mini bus for a family trip, and the service was outstanding. The vehicle was comfortable, and the driver made sure everything went smoothly. Highly recommend Amruta Travels for group travel!',
    rating: 5,
  },
];














































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/mini-bus-on-rent.jpg", // Update with actual image URL
  "description": "Mini bus rental services in Pune for outstation trips, corporate events, picnics, and family trips. Available in 12-seater and 17-seater options. Book your mini bus hire for weddings, parties, or weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "850"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000", // Adjust price as per service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/mini-bus-on-rent"
  }
};




    return (
        <div>



<Helmet>
  <title>Call: +91 7353109555 | Mini Bus On Rent in Pune | Affordable Mini Bus Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent a mini bus in Pune for corporate trips, weddings, picnics, and outstation travel. Choose from 12-seater and 17-seater mini buses with driver. Book now!" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/76.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Minibusonrent;